export const capitilize = (value:string):string =>{

    let res:string = value.slice(0,1).toLocaleUpperCase() + value.slice(1);
    

    
    
    
    return res;


}